import { actions } from '../constants/activityMultiply';
import * as actionTypes from '../../models/action/activityMultiply';
import { ActivityType, ActivityTypeEnums } from '../../models/enums/ActivityType';
import { CourseContentMenuType } from '../../models/enums/CourseContentMenuType';
import * as types from '../../models/action/coursePage';

export function GetActivityCopyData(spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.IGetActivityCopyDatas {
    return{
        type: actions.GET_ACTIVITY_COPY_DATAS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function SetActivityCopyData(activityCopyDatas: Array<actionTypes.IActivityCopyData>, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ISetActivityCopyDatas {
    return{
        activityCopyDatas,
        type: actions.SET_ACTIVITY_COPY_DATAS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function GetActivityList( 
    CourseId: string,
    ClassId: string | null,
    TermWeekId: string | null,
    weekZero?: boolean | undefined,
    IsWeekly?: boolean | null,
    Take?: number,
    Skip?: number,
    OrderBy?: string | null,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypes.IGetActivityCopyList {
    return {
        CourseId,
        ClassId,
        TermWeekId,
        weekZero,
        IsWeekly,
        Take,
        Skip,
        OrderBy,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_MULTIPLY_LIST
    };
}

export function SetActivityList(
    courseActivityList?: Array<{
    activityId?: string | null,
    name?: string | null,
    activityType: ActivityType | null,
    prerequisiteActivity: number | null,
    prerequisiteActivityName:string | null,
    isCommon: boolean | null,
    termWeekId: string | null,
    totalCount: number,
    beginDate: Date | null,
    endDate: Date | null,
    actualStartTime: Date | null,
    actualEndTime: Date | null,
    }> | null, 
    spinnerId?: string | null, 
    spinnerType?: 'get' | 'set') : actionTypes.ISetActivityCopyList {
    return{
        courseActivityList,
        type: actions.SET_ACTIVITY_MULTIPLY_LIST,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function SetActivityCopyList(activityCopyDatas: Array<actionTypes.IActivityCopyData>, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ISetActivityCopyDatas {
    return{
        activityCopyDatas,
        type: actions.SET_ACTIVITY_COPY_DATAS,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function getStartActivityMultiple(
    MultiplyActivitiesList: string | null, 
    ActivityId: string | null,
    Display: string | null, 
    spinnerId?: string, 
    spinnerType?: 'get' | 'set') : actionTypes.IGetStartMultiply {
    return{
        MultiplyActivitiesList,
        ActivityId,
        Display, 
        type: actions.GET_START_ACTIVITY_MULTIPLY,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function setStartActivityMultiple(
    multiplyResultData: {
        success: boolean | null
    } | null, 
    spinnerId?: string | null, 
    spinnerType?: 'get' | 'set') : actionTypes.IMultiplyResultData {
    return{
        multiplyResultData,
        type: actions.SET_START_ACTIVITY_MULTIPLY,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}

export function GetActivityMultiplyData( 
    activityId: string,
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypes.IGetActivityMultiplyData {
    return {
        activityId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_MULTIPLY_DATA
    };
}

export function SetActivityMultiplyData(
    activityMultiplyDataList: {
    virtualClassTime?: string | null,
    activityDuration?: string | null,
    } | null, 
    spinnerId?: string | null, 
    spinnerType?: 'get' | 'set') : actionTypes.ISetActivityMultiplyData {
    return{
        activityMultiplyDataList,
        type: actions.SET_ACTIVITY_MULTIPLY_DATA,
        timestamp: Date.now(),
        spinnerId,
        spinnerType
    };
}
